import { pageSelectorGenerator } from '@test/pageSelectors';

export const ContentHeaderSelectors = pageSelectorGenerator('ContentHeader', ['ContentHeaderHedText', 'ContentHeaderDekText']);
